import type { CompRef } from '@wix/document-services-types';
import { AppControllerRef } from '@wix/document-services-types';
import { BindingKey } from '@wix/binding-key-manager';
import { PrivateAPINamespace } from '../PrivateAPINamespace';
import { ApiConfig, Private } from '../../limitPrivateAPI';
import type { EditorPointer } from '@wix/editor-document-logic-api';

export class CMSBindingsNamespace extends PrivateAPINamespace {
  static readonly namespace = 'cmsBindings';

  @ApiConfig(Private)
  private get bindingsService() {
    return this.ps.manifestServicesHost.getComponentsService().bindings;
  }

  create<T = unknown>(
    editorPointer: EditorPointer<CompRef>,
    controllerRef: AppControllerRef,
    options: {
      key: BindingKey;
      role: string;
      config: T;
    },
  ): T {
    return this.bindingsService.create<T>(editorPointer, controllerRef, {
      role: options.role,
      config: options.config,
      key: options.key,
    });
  }

  delete(editorPointer: EditorPointer<CompRef>, key: BindingKey): void {
    return this.bindingsService.delete(editorPointer, key);
  }

  update<T = unknown>(
    editorPointer: EditorPointer<CompRef>,
    key: BindingKey,
    options: {
      config: T;
      role?: string;
    },
  ): T {
    return this.bindingsService.update<T>(editorPointer, key, options);
  }

  get<T = unknown>(
    editorPointer: EditorPointer<CompRef>,
    key: BindingKey,
  ): T | null {
    return this.bindingsService.get<T>(editorPointer, key);
  }

  getBindableControllers(
    editorPointer: EditorPointer<CompRef>,
  ): AppControllerRef[] {
    return this.bindingsService.getBindableControllers(editorPointer);
  }

  isBindable(editorPointer: EditorPointer<CompRef>): boolean {
    return this.bindingsService.isBindable(editorPointer);
  }

  openDataBindingPanel(id: string) {
    return this.ps.hostAPI.editor.openPropertyBindingPanel({ dataItemId: id });
  }
}
